import React, { useEffect, useState } from 'react';
import { fetchCompanyGroups, createCompanyGroup, updateCompanyGroup } from '../../utils/requestUtils';
import { makeRequest } from '../../utils/httpRequest';
import { useNavigate } from 'react-router-dom';
import Config from '../../core/config';
import CentralizedView from '../common/CentralizedView';
import ActionButtonsManagerView from '../common/ActionButtonsManagerView';
import ConfirmButton from '../common/ConfirmButton';

const apiUrl = Config.apiUrl;

const CompanyGroupManager = () => {
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const [availablePermissions, setAvailablePermissions] = useState([]);
    const [formData, setFormData] = useState({ name: '', permissions: [] });
    const [loading, setLoading] = useState(true);
    const [permissionFilter, setPermissionFilter] = useState('');

    useEffect(() => {
        async function fetchPermissions() {
            const response = await makeRequest(apiUrl + '/api/companypermission/companies_permission_info', 'GET');
            setAvailablePermissions(response);
        }
        fetchPermissions();
    }, []);

    useEffect(() => {
        if (id) {
            setLoading(true);
            fetchCompanyGroups().then(groups => {
                const group = groups.find(g => g.id === parseInt(id));
                if (group) setFormData({ name: group.name, permissions: group.permissions });
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [id]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePermissionChange = (e) => {
        const { value, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            permissions: checked
                ? [...prev.permissions, value]
                : prev.permissions.filter(p => p !== value)
        }));
    };

    const onConfirm = async () => {
        if (!formData.name) {
            alert('Preencha o nome do grupo.');
            return;
        }
        setLoading(true);
        if (id) {
            await updateCompanyGroup(id, formData);
        } else {
            await createCompanyGroup(formData);
        }
        setLoading(false);
        navigate('/admin/companygrouplist');
    };

    // Filtrar permissões baseado no texto de busca
    const filteredPermissions = availablePermissions.filter(permission =>
        permission.description.toLowerCase().includes(permissionFilter.toLowerCase()) ||
        permission.permission.toLowerCase().includes(permissionFilter.toLowerCase())
    );

    if (loading) return <div>Carregando...</div>;

    return (
        <CentralizedView>
            <div className="app-form-page">
            <div className="header-label">{id ? 'Editar' : 'Novo'} Grupo de Permissões</div>
            <div style={{ marginTop: '5px', display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '180px' }}>Nome do Grupo:</div>
                <input type="text" name="name" value={formData.name} onChange={handleChange} />
            </div>
            
            <div style={{ marginTop: '15px' }}>
                <div style={{ width: '180px', marginBottom: '10px' }}>Permissões:</div>
                
                {/* Campo de filtro */}
                <div style={{ marginBottom: '10px' }}>
                    <input
                        type="text"
                        placeholder="Filtrar permissões..."
                        value={permissionFilter}
                        onChange={(e) => setPermissionFilter(e.target.value)}
                        style={{ width: '300px', padding: '5px' }}
                    />
                </div>
                
                {filteredPermissions.length > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                        <input
                            type="checkbox"
                            checked={filteredPermissions.every(p => formData.permissions.includes(p.permission))}
                            onChange={e => {
                                setFormData(prev => ({
                                    ...prev,
                                    permissions: e.target.checked ? filteredPermissions.map(p => p.permission) : []
                                }));
                            }}
                        />
                        <span style={{ marginLeft: 8 }}>Selecionar/Desmarcar todas</span>
                    </div>
                )}
                
                <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px' }}>
                    {filteredPermissions.length > 0 ? (
                        filteredPermissions.map((permission) => (
                            <div key={permission.permission} style={{ display: "flex", alignItems: "center", marginBottom: '5px' }}>
                                <label style={{ display: "flex", alignItems: "center" }}>
                                    <input
                                        type="checkbox"
                                        value={permission.permission}
                                        checked={formData.permissions.includes(permission.permission)}
                                        onChange={handlePermissionChange}
                                    />
                                    <span style={{ marginLeft: '8px' }}>
                                        {permission.description}
                                    </span>
                                </label>
                            </div>
                        ))
                    ) : (
                        <div style={{ color: '#888', textAlign: 'center' }}>
                            {permissionFilter ? 'Nenhuma permissão encontrada com o filtro aplicado.' : 'Nenhuma permissão disponível.'}
                        </div>
                    )}
                </div>
            </div>
            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm} />
            </ActionButtonsManagerView>
            </div>
        </CentralizedView>
    );
};

export default CompanyGroupManager; 